import { Injectable, inject } from '@angular/core';
import { MfaService } from '@services/auth/mfa.service';

/**
 * 2FA status of the profile being shown. Provided by ProfileComponent (not root): the desktop dialog and
 * the mobile sheet each render their own ProfileMfaSectionComponent, and the status must survive those
 * sections being re-created (dialog reopened within the profile cache, viewport change) without a refetch.
 */
@Injectable()
export class ProfileMfaStateService {
	private readonly mfaService = inject(MfaService);

	/** A verified TOTP factor exists (bound to the toggle) */
	enabled = false;
	factorId: string | null = null;
	isLoaded = false;
	/** Status could not be loaded: the toggle is disabled (unknown is not "off") and a retry is offered */
	loadError = false;
	/** Enrollment dialog open */
	showDialog = false;
	isEnrolling = false;

	/** Forget the previous profile's status (a new profile load starts from "off") */
	reset(): void {
		this.enabled = false;
		this.factorId = null;
	}

	load(): void {
		this.loadError = false;
		this.isLoaded = false;
		this.mfaService.listFactors().subscribe({
			next: (response) => {
				const factors = response?.factors || [];
				const totpFactor = factors.find((f: any) => f.factor_type === 'totp' && f.status === 'verified');

				this.enabled = !!totpFactor;
				this.factorId = totpFactor?.id || null;
				this.isLoaded = true;
			},
			error: () => {
				this.loadError = true;
				this.isLoaded = true;
			},
		});
	}

	/** Enrollment dialog finished (enrolled or closed): reload the real status */
	onEnrollmentFinished(): void {
		this.isEnrolling = false;
		this.load();
	}
}
